import React from 'react';
import clsx from 'clsx';
import { InputTextarea } from 'primereact/inputtextarea';

const renderQuestions = (questions, answers) => {
    let isAnswersEmpty = false;

    if (!Array.isArray(answers)) {
        if (!Object.keys(JSON.parse(answers)).length) isAnswersEmpty = true;
    };

    if (!questions || !questions.length) return <h1 className='has-text-centered answer-title is-size-3 mt-6'>Cette campagne n'a pas de questionnaire.</h1>

    return (
        <>
            {isAnswersEmpty && <h1 className='has-text-centered answer-title is-size-3 mt-6 mb-6'>Note : Le candidat n'a pas encore répondu au questionnaire.</h1>}

            {questions.map((page, pageIndex) => (
                <div key={`page-${pageIndex}`}>
                    <h3 className="title is-3 has-text-centered mb-5 mt-5">{page.title}</h3>

                    {page.questions.map((q, qIndex) => (
                        <div key={`question-${qIndex}`} className="box mb-5 radius-15">
                            <h1 className={clsx('title is-5 answer-title mb-5', { 'has-text-centered mb-6': q.type === 'likert' })}>{q.question}</h1>

                            <h2 className="answer-title is-size-6 mb-4">
                                {q.type === 'short' && '(Question à réponse courte)'}
                                {q.type === 'long' && '(Question à réponse longue)'}
                                {q.type === 'mcq-m' && '(Question à choix multiples)'}
                                {q.type === 'mcq-u' && '(Question à choix unique)'}
                                {q.type === 'likert' && ''}
                            </h2>
                            <div className="field">
                                {q.type === 'short' && (
                                    <div className="control">
                                        <InputTextarea className='is-fullwidth p-3' value={answers[pageIndex]?.[qIndex] || ''} rows={3} autoResize readOnly />
                                    </div>
                                )}

                                {q.type === 'long' && (
                                    <div className="control">
                                        <InputTextarea className='is-fullwidth p-3' value={answers[pageIndex]?.[qIndex] || ''} rows={3} autoResize readOnly />
                                    </div>
                                )}

                                {q.type === 'mcq-m' && (
                                    q.choices.map((choice, j) => (
                                        <div key={`choice-mcq-m-${pageIndex}-${qIndex}-${j}`} className="field">
                                            <label className="answer-mcq">
                                                <input
                                                    type="checkbox"
                                                    className='answer-mcq-input'
                                                    name={`${pageIndex}-${qIndex}`}
                                                    value={j}
                                                    checked={(answers[pageIndex]?.[qIndex] || []).includes(j)}
                                                    disabled
                                                />
                                                {choice}
                                            </label>
                                        </div>
                                    ))
                                )}

                                {q.type === 'mcq-u' && (
                                    q.choices.map((choice, j) => (
                                        <div key={`choice-mcq-u-${pageIndex}-${qIndex}-${j}`} className="field">
                                            <label className="answer-mcq">
                                                <input
                                                    type="radio"
                                                    className='answer-mcq-input'
                                                    name={`${pageIndex}-${qIndex}`}
                                                    value={j}
                                                    checked={(answers[pageIndex]?.[qIndex] || [])[0] === j}
                                                    disabled
                                                />
                                                {choice}
                                            </label>
                                        </div>
                                    ))
                                )}

                                {q.type === 'likert' && (
                                    <div className="likert-scale-container">
                                        <table className="table is-fullwidth">
                                            <thead>
                                                <tr>
                                                    <th className='has-text-centered is-borderless'></th>
                                                    <th className='likert-title answer-title has-text-centered is-borderless'>Pas du tout d'accord</th>
                                                    <th className='likert-title answer-title has-text-centered is-borderless'>Pas d'accord</th>
                                                    <th className='likert-title answer-title has-text-centered is-borderless'>Sans opinion</th>
                                                    <th className='likert-title answer-title has-text-centered is-borderless'>Plutôt d'accord</th>
                                                    <th className='likert-title answer-title has-text-centered is-borderless'>Tout à fait d'accord</th>
                                                </tr>
                                            </thead>
                                            <tbody className='has-text-centered'>
                                                {q.choices.map((choice, j) => (
                                                    <tr key={`likert-${pageIndex}-${qIndex}-${j}`}>
                                                        <td className='likert-text has-text-justified is-borderless'>{choice}</td>
                                                        {[1, 2, 3, 4, 5].map((num) => (
                                                            <td key={`likert-${pageIndex}-${qIndex}-${j}-${num}`} className='is-borderless'>
                                                                <input
                                                                    type="radio"
                                                                    className='answer-radio-input'
                                                                    name={`${pageIndex}-${qIndex}-${j}`}
                                                                    value={num}
                                                                    checked={answers[pageIndex]?.[qIndex]?.[j] === num}
                                                                    disabled
                                                                />
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}

                    <hr className="is-invisible" />

                </div>
            ))
            }
        </>
    );
};

export default renderQuestions;